<script setup lang="ts">
import { EDashboardType } from "@/app/data/dashboard/dashboard.types";
import BarChart from "@/assets/icons/bar-chart.svg?component";
import { IPodiumItem } from "@/components/data/dashboard/insights-podium/insights-podium.types";
import { useTypedIntl } from "@/locales/typed-intl";

import Skeleton from "primevue/skeleton";

import DashboardCard from "@/components/data/dashboard/dashboard-card.vue";
import InsightsPodium from "@/components/data/dashboard/insights-podium/insights-podium.vue";

interface IProps {
  items?: IPodiumItem[];
  isLoading?: boolean;
  type: EDashboardType;
}

const props = defineProps<IProps>();

const { t, k } = useTypedIntl();
</script>

<template>
  <DashboardCard :title="t(k.data.dashboard.insights.ranking.title[props.type])">
    <template #title-icon>
      <div class="bg-gray-100 rounded-full !w-[20px] !h-[20px] flex justify-center items-center">
        <BarChart />
      </div>
    </template>

    <Skeleton
      v-if="props.isLoading"
      class="!h-56"
    />

    <div
      v-else
      class="h-full w-full rounded-md flex items-center justify-center"
    >
      <div class="p-4 w-full flex">
        <InsightsPodium
          :items="props.items"
          :type="props.type"
        />
      </div>
    </div>
  </DashboardCard>
</template>
